import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ColumnRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          clipRule="evenodd"
          d="M8.5 2a.5.5 0 0 0-1 0v2.5H5a.5.5 0 0 0 0 1h2.5V8a.5.5 0 0 0 1 0V5.5H11a.5.5 0 0 0 0-1H8.5V2Zm4.293 8.5-2.147-2.146a.5.5 0 0 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H2a.5.5 0 0 1 0-1h10.793Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ColumnRight
